/**
 * @version 1.0.1
 * @author wuwg  <wuwg@thunisoft.com>
 * @createTime:2019-08-13,
 * @updateTime:2019-08-13
 * @copyright thunisoft fd
 * @description  *  [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 *  [jsdoc-vuejs]{@link  http://npm.taobao.org/package/jsdoc-vuejs}  -
 *  [个人博客]{@link  http://www.wuweigang.com}
 */
export default {
    name: 'pmxx',
    props:{
        activePmlx:{
            type:String,
            default:''
        }
    },
    data() {
        return {
            // 拍卖附件类型
            pmfjlx: '19',
            // 搜索条件
            searchList: {
                cbpm: [
                    {
                        name: '发布法院',
                        key: 'fydm',
                        list: [
                            {name: '全部', key: ''},
                            {name: '大连海事法院', key: '732'},
                            {name: '天津海事法院', key: '72'},
                            {name: '青岛海事法院', key: '2010'},
                            {name: '南京海事法院', key: '1151'},
                            {name: '上海海事法院', key: '1129'},
                            {name: '武汉海事法院', key: '2367'},
                            {name: '宁波海事法院', key: '1402'},
                            {name: '厦门海事法院', key: '1693'},
                            {name: '广州海事法院', key: '2701'},
                            {name: '北海海事法院', key: '2878'},
                            {name: '海口海事法院', key: '2925'}
                        ]
                    },
                    {
                        name: '拍卖状态',
                        key: 'pmzt',
                        list: [
                            {name: '全部', key: ''},
                            {name: '即将开始', key: '1'},
                            {name: '正在进行', key: '2'},
                            {name: '已结束', key: '3'}
                        ]
                    }
                    // {
                    //     name: '船舶类型',
                    //     key: 'cblx',
                    //     list: [
                    //         {name: '全部', key: ''},
                    //         {name: '固体散货船', key: '1'},
                    //         {name: '液体散货船', key: '2'},
                    //         {name: '集装箱船', key: '3'},
                    //         {name: '邮轮', key: '4'},
                    //         {name: '油轮', key: '5'},
                    //         {name: '渔船', key: '6'},
                    //         {name: '工程船', key: '7'},
                    //         {name: '客船', key: '8'},
                    //         {name: '干货船', key: '9'},
                    //         {name: '多用途船', key: '10'}
                    //     ]
                    // }
                ],
                qtpm: [
                    {
                        name: '发布法院',
                        key: 'fydm',
                        list: [
                            {name: '全部', key: ''},
                            {name: '大连海事法院', key: '732'},
                            {name: '天津海事法院', key: '72'},
                            {name: '青岛海事法院', key: '2010'},
                            {name: '南京海事法院', key: '1151'},
                            {name: '上海海事法院', key: '1129'},
                            {name: '武汉海事法院', key: '2367'},
                            {name: '宁波海事法院', key: '1402'},
                            {name: '厦门海事法院', key: '1693'},
                            {name: '广州海事法院', key: '2701'},
                            {name: '北海海事法院', key: '2878'},
                            {name: '海口海事法院', key: '2925'}
                        ]
                    },
                    {
                        name: '拍卖状态',
                        key: 'pmzt',
                        list: [
                            {name: '全部', key: ''},
                            {name: '即将开始', key: '1'},
                            {name: '正在进行', key: '2'},
                            {name: '已结束', key: '3'}
                        ]
                    },
                    {
                        name: '标的物类型',
                        key: 'bdlb',
                        list: [
                            {name: '全部', key: ''},
                            {name: '森林、林木使用权', key: '3'},
                            {name: '集体土地使用权', key: '4'},
                            {name: '土地使用权', key: '5'},
                            {name: '房产', key: '6'},
                            {name: '交通运输工具', key: '7'},
                            {name: '机器设备', key: '8'},
                            {name: '产品、原材料', key: '9'},
                            {name: '古玩字画', key: '10'},
                            {name: '珠宝玉石首饰', key: '11'},
                            {name: '基金', key: '12'},
                            {name: '债权', key: '13'},
                            {name: '债券', key: '14'},
                            {name: '股票', key: '15'},
                            {name: '股权', key: '16'},
                            {name: '知识产权', key: '17'},
                            {name: '挖矿、采矿权', key: '18'},
                            {name: '其他财产', key: '255'}
                        ]
                    }
                ]
            },
            searchData: {
                fydm: '',
                pmzt: '',
                cblx: '',
                bdlb: '19'
            },
            total:10,
            data: {data:[]}
        };
    },
    watch:{
        activePmlx:{
            handler() {
                this.init();
            },
            immediate:true
        }
    },
    methods: {
        init() {
            this.changePmlx(this.activePmlx);
        },
        dealMoney(money) {
            if (money) {
                const arr1 = money.toString().split('.');
                const arr2 = arr1[0].split('').reverse();
                const arr3 = [];
                if (arr2.length > 3) {
                    for (let i = 0; i < arr2.length; i++) {
                        arr3.push(arr2[i]);
                        if (i % 3 === 2 && i !== arr2.length - 1) {
                            arr3.push(',');
                        }
                    }
                    arr1[0] = arr3.reverse().join('');
                    return arr1.join('.');
                }
                return money;
            }
        },
        // 切换拍卖类型
        changePmlx(code) {
            this.activePmlx = code;
            this.data = {data:[]};
            if (code === 'cbpm') {
                this.searchData = {
                    fydm: '',
                    pmzt: '',
                    cblx: '',
                    bdlb: '19'
                };
            } else {
                this.searchData = {
                    fydm: '',
                    pmzt: '',
                    cblx: '',
                    bdlb: ''
                };
            }
            this.getPmxx({limit:6});
        },
        // 切换筛选条件
        clickSearch(key, key01) {
            this.searchData[key] = key01;
            this.getPmxx({limit:6});
        },
        // 点击跳转详情
        clickXq(item) {
            const routeUrl = this.$router.resolve({path: '/kypm/xq', query: {bh: item.bh, bdlb: item.bdlb, lx: this.pmfjlx}});
            window.open(routeUrl.href, '_blank');
        },
        // 获取拍卖信息
        getPmxx(queryInfo) {
            let params = this.searchData;
            if (queryInfo) {
                params = {
                    ...queryInfo,
                    ...params
                };
            }
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.kypm.pmxx,
                params: params
            }).then((res) => {
                this.initData(res.data);
            });
        },
        initData(data) {
            data.data.forEach((item) => {
                item.bdwzpdz = item.bdwzpdz || '/static/image/img-zwsj.png';
            });
            // 船舶拍卖
            this.data = data;
        }
    }
};

